<template>
  <div class="navBar">
    <van-nav-bar :title="browserHeaderTitle"
                 left-text=""
                 :left-arrow="leftArrow"
                 @click-left="$router.back()" />
  </div>
</template>

<script>
export default {
  name: 'navBar',
  computed: {
    browserHeaderTitle () {
      return this.$store.getters.browserHeaderTitle
    }
  },
  props: {
    leftArrow: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
.navBar {
  height: 122px;
  position: fixed;
  padding-top: 30px;
  z-index: 100;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue